import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

function VerificationRequired({ email }) {
  const { t: tr } = useTranslation();
  return (
    <div className="alert alert-info" role="status">
      <p>{tr("auth:neutralVerification")} {email}.</p>
    </div>
  );
}

VerificationRequired.propTypes = {
  email: PropTypes.string.isRequired,
};

export default VerificationRequired;
